<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import AddOrder from "./addOrder.vue";
import ReceivedOrder from "./receiveOrder.vue";
import axios from "axios";
import { RAW_MATERIAL_PATH } from "../../../../path";
import moment from "moment";
import Swal from "sweetalert2";
export default {
  components: {
    Layout,
    PageHeader,
    AddOrder,
    ReceivedOrder,
  },
  data() {
    return {
      title: "Raw Material Invard",
      items: [
        {
          text: "List",
        },
        {
          text: "Invard Orders",
          active: true,
        },
      ],
      orders: [],
      currentPage: 1,
      key: 1,
      fields: [
        "vendor",
        "invoice_number",
        "no_of_items",
        "invoice_date",
        "Docs",
        "actions",
      ],
      filter: null,
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      cdn: process.env.VUE_APP_AWS_CDN,
      search: "",
      selectedOrder: null,
      order_status: "pending",
      is_view: false,
    };
  },
  methods: {
    addOrder() {
      this.$bvModal.show("add-order");
    },
    async getOrders() {
      try {
        let res = await axios.get(
          this.base_url + RAW_MATERIAL_PATH.GET_ORDERS,
          {
            params: {
              page: this.currentPage,
              search: this.filter,
              status: this.order_status,
            },
          }
        );
        if (res.data.status) {
          this.orders = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    formatedDate(v) {
      return moment(v).format("YYYY-MM-DD");
    },
    setEdit(v, is_view = false) {
      this.selectedOrder = v;
      this.is_view = is_view;
      this.$bvModal.show("add-order");
    },
    markAsRecived(v) {
      this.selectedOrder = v;
      this.is_view = true;
      this.$bvModal.show("mark-as-received");
    },
    reload() {
      this.selectedOrder = null;
      this.$bvModal.hide("add-order");
      this.$bvModal.hide("mark-as-received");
      this.getOrders();
    },
    async deleteItem(v) {
      try {
        let res = await axios.delete(
          this.base_url + RAW_MATERIAL_PATH.DELETE_ORDER,
          {
            params: {
              invoice_date: v.invoice_date,
              invoice_number: v.invoice_number,
              vendor: v.vendor,
              status: v.status,
              date_of_receiving: v.date_of_receiving,
            },
          }
        );
        if (res.data.status) {
          Swal.fire("Order Removed Successfully", "", "success");
          this.getOrders();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async download_po(v) {
      try {
        let res = await axios.post(
          this.base_url + RAW_MATERIAL_PATH.DOWNLOAD_PO,
          {
            invoice_date: v.invoice_date,
            invoice_number: v.invoice_number,
            vendor: v.vendor,
            status: v.status,
            date_of_receiving: v.date_of_receiving,
          }
        );
        if (res.data.status) {
          Swal.fire("Success", "", "success");
          this.getOrders();
        } else {
          throw new Error(res.data.message);
        }
      } catch (error) {
        console.log(error);
        Swal.fire(error.message, "", "error");
      }
    },
    onFiltered() {
      //   this.totalRows = filteredItems.length;
      //   this.currentPage = 1;
    },
  },
  watch: {
    currentPage() {
      this.getOrders();
    },
    order_status() {
      this.getOrders();
    },
    search() {
      this.getOrders();
    },
    filter() {
      this.getOrders();
    },
  },
  mounted() {
    this.getOrders();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-modal id="add-order" size="xl" hide-footer>
        <AddOrder
          @reload="reload"
          :selectedOrder="selectedOrder"
          :is_view="is_view"
        ></AddOrder>
      </b-modal>
      <b-modal id="mark-as-received" size="xl" hide-footer>
        <ReceivedOrder
          @reload="reload"
          :selectedOrder="selectedOrder"
          :is_view="is_view"
        ></ReceivedOrder>
      </b-modal>
      <b-card-header>
        <b-button variant="primary" @click="addOrder"> + Raise PO</b-button>
      </b-card-header>
      <div class="col-sm-12 col-md-12 mt-3">
        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
          <label class="d-inline-flex align-items-center mr-5">
            Search:
            <b-form-input
              v-model="filter"
              type="search"
              class="form-control form-control-sm ml-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <b-tabs class="mt-3">
        <b-tab title="Pending" @click="order_status = 'pending'"></b-tab>
        <b-tab title="Received" @click="order_status = 'received'"></b-tab>
      </b-tabs>
      <div class="table-responsive">
        <b-table
          :key="orders.key"
          :items="orders.data"
          :fields="fields"
          responsive="sm"
          :filter="filter"
          :current-page="currentPage"
        >
          <template v-slot:cell(no_of_items)="row">
            {{ row.item.items }}
          </template>
          <template v-slot:cell(invoice_date)="row">
            {{ formatedDate(row.item.invoice_date) }}
          </template>
          <template v-slot:cell(vendor)="row">
            {{ row.item.vendor_details?.name }}
          </template>
          <template v-slot:cell(status)="row">
            {{ row.item.status }}
          </template>
          <template v-slot:cell(docs)="row">
            <a
              :href="cdn + '/' + row.item.po_url"
              v-if="row.item.po_url != null"
              target="_blank"
            >
              <b-button variant="primary"
                ><i class="fa fa-download"> PO</i></b-button
              >
            </a>
            <p v-if="row.item.status != 'received'" class="m-2">
              <b-button variant="primary" @click="download_po(row.item)"
                ><i class="fa fa-recycle">
                  {{ row.item.po_url != null ? "Re-" : "" }}Generate PO</i
                ></b-button
              >
            </p>
            <a
              class="m-1"
              target="_blank"
              v-if="row.item.status == 'received' && row.item.grn_url != ''"
              :href="cdn + '/' + row.item.grn_url"
              ><b-button variant="success" class="mr-3"
                ><i class="fa fa-download"> GRN</i></b-button
              ></a
            >
          </template>
          <template v-slot:cell(actions)="row">
            <b-button
              variant="success"
              class="mr-3"
              v-if="row.item.status == 'pending'"
              size="sm"
              @click="markAsRecived(row.item)"
              >Generate Grn</b-button
            >
            <b-button
              variant="primary"
              v-if="row.item.status == 'pending'"
              size="sm"
              @click="setEdit(row.item)"
              ><i class="fa fa-pen"></i
            ></b-button>
            <b-button
              variant="primary"
              v-if="row.item.status == 'received'"
              size="sm"
              @click="setEdit(row.item, true)"
              ><i class="fa fa-eye"></i
            ></b-button>
            <b-button
              variant="danger"
              v-if="row.item.status == 'pending'"
              size="sm"
              class="ml-3"
              @click="deleteItem(row.item)"
              ><i class="fa fa-trash"></i
            ></b-button>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                :key="orders.key"
                v-model="currentPage"
                :total-rows="orders.total"
                :per-page="orders.per_page"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card>
  </Layout>
</template>

<style></style>
